import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-navy" />
      </div>
    )
  }

  if (!isAuthenticated) {
    sessionStorage.setItem('storefront-return-to', location.pathname)
    return <Navigate to="/sign-in" replace />
  }

  return <>{children}</>
}
